import { ModalsProvider } from "@mantine/modals";
import { ThemeProvider } from "@mui/material";
import { NuqsAdapter } from "nuqs/adapters/react";
import { PropsWithChildren } from "react";
import { Toaster } from "react-hot-toast";
import { Bounce, ToastContainer } from "react-toastify";

import { DriverProvider } from "@/contexts/driver";
import { ExpedProvider } from "@/contexts/exped";
import { LoaderProvider } from "@/contexts/loader";
import { VehiclesProvider } from "@/contexts/vehicles";
import { MODAL_PROPS, MODALS } from "@/lib/Mantine";
import { MUI_THEME } from "@/lib/material-ui";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <CustomProviders>
      <ThemeProvider theme={MUI_THEME}>
        <ModalsProvider modals={MODALS} modalProps={MODAL_PROPS}>
          <NuqsAdapter>{children}</NuqsAdapter>

          <Toaster position="bottom-right" />

          <ToastContainer
            hideProgressBar={false}
            position="top-right"
            closeOnClick={false}
            newestOnTop={false}
            transition={Bounce}
            pauseOnFocusLoss
            autoClose={5000}
            theme="light"
            pauseOnHover
            rtl={false}
            limit={3}
            draggable
          />
        </ModalsProvider>
      </ThemeProvider>
    </CustomProviders>
  );
}

function CustomProviders({ children }: PropsWithChildren) {
  return (
    <LoaderProvider>
      <DriverProvider>
        <VehiclesProvider>
          <ExpedProvider>{children}</ExpedProvider>
        </VehiclesProvider>
      </DriverProvider>
    </LoaderProvider>
  );
}
